import { render, staticRenderFns } from "./RateRangePlate.vue?vue&type=template&id=12cc587d"
import script from "./RateRangePlate.vue?vue&type=script&lang=js"
export * from "./RateRangePlate.vue?vue&type=script&lang=js"
import style0 from "./RateRangePlate.vue?vue&type=style&index=0&id=12cc587d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports